(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function initCarousel(carousel) {
    var track = carousel.querySelector('[data-rivanti-reviews-track]');
    var prevBtn = carousel.parentElement.querySelector('[data-rivanti-reviews-prev]');
    var nextBtn = carousel.parentElement.querySelector('[data-rivanti-reviews-next]');
    var progressThumb = carousel.parentElement.querySelector('[data-rivanti-reviews-progress]');
    if (!track) {
      return;
    }

    function scrollByCard(direction) {
      var item = track.querySelector('.rivanti-reviews--item');
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16);
      var amount = item ? item.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    function updateButtons() {
      if (!prevBtn || !nextBtn) {
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    function updateProgress() {
      if (!progressThumb) {
        return;
      }
      var maxScroll = track.scrollWidth - track.clientWidth;
      var thumbPercent = Math.min(100, (track.clientWidth / track.scrollWidth) * 100);
      var scrollPercent = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      progressThumb.style.width = thumbPercent + '%';
      progressThumb.style.left = scrollPercent * (100 - thumbPercent) + '%';
    }

    function update() {
      updateButtons();
      updateProgress();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByCard(1);
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initReadMore(root) {
    root.querySelectorAll('[data-rivanti-reviews-toggle]').forEach(function (button) {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var item = button.closest('.rivanti-reviews--item');
        if (!item) {
          return;
        }
        var expanded = item.classList.toggle('is-expanded');
        button.textContent = expanded ? button.getAttribute('data-less') : button.getAttribute('data-more');
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-rivanti-reviews-carousel]').forEach(initCarousel);
    document.querySelectorAll('.rivanti-reviews').forEach(initReadMore);
  });
})();
